import { useEffect, useState, useContext } from 'react';
import pushNotificationService from '../services/pushNotificationService';
import { AuthContext } from '../context/Auth/AuthContext';

const usePushNotifications = () => {
  const authContext = useContext(AuthContext);
  const user = authContext?.user;
  const [isSupported, setIsSupported] = useState(false);
  const [permission, setPermission] = useState('default');
  const [isRegistered, setIsRegistered] = useState(false);

  useEffect(() => {
    // Verificar se push notifications são suportadas
    const supported = pushNotificationService.isPushSupported();
    setIsSupported(supported);

    if (supported) {
      // Verificar permissão atual
      pushNotificationService.getPermissionStatus().then(setPermission);
    }
  }, []);

  useEffect(() => {
    // Verificar se já existe subscription quando permissão está granted
    if (user?.id && isSupported && permission === 'granted' && !isRegistered) {
      // Aguardar um pouco para garantir que o service worker está pronto
      const timer = setTimeout(() => {
        registerPushSubscription();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [user?.id, isSupported, permission, isRegistered]);

  const requestPermission = async () => {
    if (!isSupported) {
      console.warn('Push notifications não são suportadas neste navegador');
      return false;
    }

    try {
      const subscription = await pushNotificationService.registerPushSubscription(user?.id);
      if (subscription) {
        setIsRegistered(true);
        setPermission('granted');
        return true;
      }
      return false;
    } catch (error) {
      console.error('Erro ao solicitar permissão de push:', error);
      return false;
    }
  };

  const registerPushSubscription = async () => {
    if (!user?.id) return;

    try {
      const subscription = await pushNotificationService.registerPushSubscription(user.id);
      if (subscription) {
        setIsRegistered(true);
        console.log('Push subscription registrada com sucesso');
      }
    } catch (error) {
      console.error('Erro ao registrar push subscription:', error);
    }
  };

  const unregisterPushSubscription = async (subscriptionId) => {
    try {
      await pushNotificationService.unregisterPushSubscription(subscriptionId);
      setIsRegistered(false);
      setPermission('default');
    } catch (error) {
      console.error('Erro ao remover push subscription:', error);
    }
  };

  return {
    isSupported,
    permission,
    isRegistered,
    requestPermission,
    registerPushSubscription,
    unregisterPushSubscription
  };
};

export default usePushNotifications;

